// Single source of truth for the two localStorage markers that record WHICH auth
// method minted the active session, and whether that session owns a hosted
// issuer browser cookie. Every writer must go through setStoredAuthMethod():
// a provider that writes the method key directly leaves a stale
// `bounded_issuer_session_kind` behind, which is what taught logout() to bounce
// a wallet reader at an issuer that has no /logout route.
import { getPlatform } from '../platform';
export const STORED_AUTH_METHOD_KEY = 'bounded_last_auth_method';
export const ISSUER_SESSION_KIND_KEY = 'bounded_issuer_session_kind';
export function getStoredAuthMethod() {
    try {
        return getPlatform().storage.getItem(STORED_AUTH_METHOD_KEY);
    }
    catch (_a) {
        return null;
    }
}
export function setStoredAuthMethod(method) {
    try {
        if (method) {
            getPlatform().storage.setItem(STORED_AUTH_METHOD_KEY, method);
        }
        else {
            getPlatform().storage.removeItem(STORED_AUTH_METHOD_KEY);
        }
        // Non-email providers cannot own a Better Auth browser session. Clear
        // any prior hosted/inline classification when the active provider is
        // replaced or the session is removed.
        if (method !== 'email') {
            getPlatform().storage.removeItem(ISSUER_SESSION_KIND_KEY);
        }
    }
    catch (_a) {
        // storage might not be available
    }
}
export function getIssuerSessionKind() {
    try {
        return getPlatform().storage.getItem(ISSUER_SESSION_KIND_KEY);
    }
    catch (_a) {
        return null;
    }
}
